export default {"src":"/_next/static/media/midway-journey.97430ae0.svg","height":100,"width":100};